import { useState } from "react";
import { COLORS } from "../../../theme/colors";
import KnowledgeUploadPanel from "./KnowledgeUploadPanel";
import KnowledgeLibraryPanel from "./KnowledgeLibraryPanel";
import KnowledgeJobsPanel from "./KnowledgeJobsPanel";
import KnowledgeSettingsPanel from "./KnowledgeSettingsPanel";
import KnowledgeFamilyPanel from "./KnowledgeFamilyPanel";

// Phase B per agent-detail-viewer-v1.md §10 row 13. Sub-tab strip +
// per-sub-tab body. Upload sub-tab is the B13 deliverable; Library /
// Jobs / Settings get filled by B14 / B15 / B16 (placeholders for now).
//
// "family" sub-tab (Pass 1 of Knowledge simplification, 2026-05-05):
// supervisor-only; cascade-from-supervisor view of template /
// embedding model / processing config across the family.

const SUB_TAB_LABEL = {
  family: "Family", upload: "Upload", library: "Library", jobs: "Jobs", settings: "Settings",
};

export default function KnowledgeTab({ tree, currentUser, onOpenDrawer }) {
  const agent = tree?.agent;
  const isSupervisor = (tree?.agent_kind || tree?.agent?.metadata_json?.agent_kind) === "supervisor";
  const hasExperts = (tree?.experts || []).length > 0;
  const showFamily = isSupervisor && hasExperts;
  // Sub-tab list adapts: "family" only appears for supervisors with
  // experts; default-active when present so the cascade view is the
  // landing surface. Keeps the per-agent panels available for
  // surgical edits.
  const SUB_TABS = showFamily
    ? ["family", "upload", "library", "jobs", "settings"]
    : ["upload", "library", "jobs", "settings"];
  const [active, setActive] = useState(showFamily ? "family" : "upload");

  const stub = (label) => (
    <div style={{ color: COLORS.textDim, fontSize: 12, padding: 24 }}>
      {`<${label}> — placeholder; filled in by a later Phase B item.`}
    </div>
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      {/* Sub-tab strip */}
      <div style={{
        display: "flex", gap: 4, borderBottom: `1px solid ${COLORS.border}`,
        paddingBottom: 0,
      }}>
        {SUB_TABS.map(t => {
          const on = t === active;
          return (
            <button key={t} onClick={() => setActive(t)} style={{
              background: "transparent", border: "none",
              color: on ? COLORS.text : COLORS.textDim,
              padding: "8px 14px", cursor: "pointer", fontSize: 12,
              fontWeight: on ? 600 : 500,
              borderBottom: `2px solid ${on ? COLORS.accent : "transparent"}`,
              marginBottom: -1, transition: "color 0.15s, border-color 0.15s",
            }}>{SUB_TAB_LABEL[t]}</button>
          );
        })}
      </div>

      {active === "family" && <KnowledgeFamilyPanel tree={tree} currentUser={currentUser} />}
      {active === "upload" && <KnowledgeUploadPanel agent={agent} />}
      {active === "library" && <KnowledgeLibraryPanel tree={tree} currentUser={currentUser} onOpenDrawer={onOpenDrawer} />}
      {active === "jobs" && <KnowledgeJobsPanel tree={tree} currentUser={currentUser} onOpenDrawer={onOpenDrawer} />}
      {active === "settings" && <KnowledgeSettingsPanel tree={tree} currentUser={currentUser} />}
    </div>
  );
}
